import React from 'react'
import { connect } from 'react-redux'
import { startOfMonth, subMonths, format, endOfMonth, subDays, startOfWeek, endOfWeek, subWeeks, startOfYear, endOfYear, subYears, parse, addMonths } from 'date-fns'
import { DateRange } from './components/react-date-range'

import Datepicker from '../UI/Datepicker'
import CurrenciesControls from './components/CurrenciesControls'
import PriorityControls from './components/PriorityControls'
import Popover from '../UI/Popover'
import { getFirstDayOfWeek } from '../../helpers/getFirstDayOfWeek'

import * as actions from './actions'

import './scss/styles.scss' // main style file
import './scss/theme/default.scss' // theme css file

const weekStartsOn = getFirstDayOfWeek()

class FiltersPanel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      key: 'selection',
      focusedRange: [0, 0],
      open: false,
      dateStartView: startOfMonth(subMonths(new Date(), 1)),
      dateStartView1: startOfMonth(new Date()),
      pickerFirstMaxdate: endOfMonth(subMonths(new Date(), 1)),
      pickerSecondMindate: startOfMonth(new Date()),
    }
  }
  handleSelect = dates => {
    const { selectStartDate, selectEndDate } = this.props
    if (dates.selection) {
      this.setState({
        key: 'selected',
        key1: 'selected',
        focusedRange: [0, 1]
      })
      selectStartDate([
        format(dates.selection.startDate, 'yyyy-MM-dd'),
        format(dates.selection.endDate, 'yyyy-MM-dd'),
      ])
    } else {
      this.setState({
        key: 'selection',
        key1: 'selection',
        focusedRange: [0, 0]
      })
      selectEndDate([
        format(dates.selected.startDate, 'yyyy-MM-dd'),
        format(dates.selected.endDate, 'yyyy-MM-dd'),
      ])
      setTimeout(() => {
        this.setIsOpen(false)
      }, 700)
    }
  }

  onChangeCurrentMonthPickerFirst = selectedMonth => {
    this.setState({
      pickerSecondMindate: startOfMonth(addMonths(selectedMonth, 1)),
    })
  }
  onChangeCurrentMonthPickerSecond = selectedMonth => {
    this.setState({
      pickerFirstMaxdate: endOfMonth(subMonths(selectedMonth, 1)),
    })
  }

  pickRange = range => {
    const { selectEndDate } = this.props
    switch (range) {
      case 'today':
        selectEndDate([
          format(new Date(), 'yyyy-MM-dd'),
          format(new Date(), 'yyyy-MM-dd'),
        ])
        break
      case 'yesterday':
        selectEndDate([
          format(subDays(new Date(), 1), 'yyyy-MM-dd'),
          format(subDays(new Date(), 1), 'yyyy-MM-dd'),
        ])
        break
      case 'week':
        selectEndDate([
          format(startOfWeek(new Date(), { weekStartsOn }), 'yyyy-MM-dd'),
          format(endOfWeek(new Date(), { weekStartsOn }), 'yyyy-MM-dd'),
        ])
        break
      case 'prevWeek':
        selectEndDate([
          format(startOfWeek(subWeeks(new Date(), 1), { weekStartsOn }), 'yyyy-MM-dd'),
          format(endOfWeek(subWeeks(new Date(), 1), { weekStartsOn }), 'yyyy-MM-dd'),
        ])
        break
      case 'month':
        selectEndDate([
          format(startOfMonth(new Date()), 'yyyy-MM-dd'),
          format(endOfMonth(new Date()), 'yyyy-MM-dd'),
        ])
        break
      case 'prevMonth':
        selectEndDate([
          format(startOfMonth(subMonths(new Date(), 1)), 'yyyy-MM-dd'),
          format(endOfMonth(subMonths(new Date(), 1)), 'yyyy-MM-dd'),
        ])
        break
      case 'year':
        selectEndDate([
          format(startOfYear(new Date()), 'yyyy-MM-dd'),
          format(endOfYear(new Date()), 'yyyy-MM-dd'),
        ])
        break
      case 'prevYear':
        selectEndDate([
          format(startOfYear(subYears(new Date(), 1)), 'yyyy-MM-dd'),
          format(endOfYear(subYears(new Date(), 1)), 'yyyy-MM-dd'),
        ])
        break
      case 'entireTime':
        selectEndDate([null, null])
        break

      default:
        break
    }
    setTimeout(() => {
      this.setIsOpen(false)
    }, 700)
  }

  setIsOpen = isOpen => {
    this.setState({
      open: isOpen
    })
  }

  handleFilterCurrencyes = event => {
    this.props.setFilterCurrencyes(event, this.props.appState)
  }

  handleFilterPriority = event => {
    this.props.setFilterPriority(event, this.props.appState)
  }

  componentDidMount() {
    this.setState({
      loading: true
    })
  }

  handleChangeTag = tagName => {
    const { setFilterTag, setFilterTagRequest } = this.props
    setFilterTag(tagName)
    setFilterTagRequest()
  }

  render() {
    const { filters } = this.props
    const currencyes = this.props.currencyes
    const selectedDateRange = this.props.selectedDateRange
    const selectionRange = {
      startDate: parse(selectedDateRange[0], 'yyyy-MM-dd', new Date()),
      endDate: parse(selectedDateRange[1], 'yyyy-MM-dd', new Date()),
      key: this.state.key
    }
    const { downloadXLSX, downloadCSV } = this.props

    const { dateStartView, dateStartView1 } = this.state

    const { pickerFirstMaxdate, pickerSecondMindate } = this.state

    return (
      <div className="tools_panel_placeholder">
        <div className="left">
          <Datepicker
            dateStart={selectionRange.startDate}
            loading={selectionRange.startDate}
            dateEnd={selectionRange.endDate}
            open={this.state.open}
            theme={'main_datepicker'}
            arrow={true}
            onRequestClose={() => {
              this.setIsOpen(false)
            }}
            onOpen={() => {
              this.setIsOpen(!this.state.open)
            }}
            html={
              <div
                style={{
                  display: 'flex',
                  padding: '30px 15px',
                  flexWrap: 'wrap'
                }}>
                <DateRange
                  months={1}
                  direction="horizontal"
                  ranges={[selectionRange]}
                  shownDate={dateStartView}
                  onChange={this.handleSelect}
                  maxDate={pickerFirstMaxdate}
                  showMonthArrow={true}
                  showDateDisplay={false}
                  showMonthAndYearPickers={false}
                  onShownDateChange={this.onChangeCurrentMonthPickerFirst}
                  focusedRange={this.state.focusedRange}
                  weekStartsOn={weekStartsOn}
                />
                <DateRange
                  months={1}
                  direction="horizontal"
                  ranges={[selectionRange]}
                  shownDate={dateStartView1}
                  onChange={this.handleSelect}
                  minDate={pickerSecondMindate}
                  maxDate={new Date()}
                  showMonthArrow={true}
                  showDateDisplay={false}
                  showMonthAndYearPickers={false}
                  onShownDateChange={this.onChangeCurrentMonthPickerSecond}
                  focusedRange={this.state.focusedRange}
                  weekStartsOn={weekStartsOn}
                />
                <div className="datepicker_footer">
                  <div className="datepicker_footer_entire_label">
                    <p
                      onClick={() => {
                        this.pickRange('entireTime')
                      }}
                      className="entire_label">
                      <span className="entire_label link">Entire time</span>
                    </p>
                  </div>
                  <div className="datepicker_footer_pickers">
                    <ul>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('today')
                          }}>
                          Today
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('yesterday')
                          }}>
                          Yesterday
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('week')
                          }}>
                          This week
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('prevWeek')
                          }}>
                          Last week
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('month')
                          }}>
                          This month
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('prevMonth')
                          }}>
                          Last month
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('year')
                          }}>
                          This year
                        </span>
                      </li>
                      <li>
                        <span
                          className="link"
                          onClick={() => {
                            this.pickRange('prevYear')
                          }}>
                          Last year
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            }
          />

          <PriorityControls
            filters={filters.priority}
            style={{ marginRight: '11px' }}
            onClick={this.handleFilterPriority}
            onTagSelect={tagName => this.handleChangeTag(tagName)}
          />
          {filters.priority.billable && (
            <CurrenciesControls
              filters={filters.currencyes}
              onClick={this.handleFilterCurrencyes}
              currencyes={currencyes}
            />
          )}
        </div>
        <div className="right">
          <span
            className="link"
            style={{ marginRight: '17px' }}
            onClick={this.props.setFilterClear}>
            Clear filters
          </span>
          <Popover downloadXLSX={downloadXLSX} downloadCSV={downloadCSV}>
            Export
          </Popover>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filtersPanel.filters,
    selectedDateRange: state.filtersPanel.selectedDateRange,
    currencyes: state.app.database.currencies
  }
}
const mapDispatchToProps = dispatch => ({
  setFilterCurrencyes: (data, state) =>
    dispatch(actions.setFilterCurrencyes(data, state)),
  setFilterPriority: (data, state) =>
    dispatch(actions.setFilterPriority(data, state)),
  setFilterTag: tagName => dispatch(actions.setFilterTag(tagName)),
  setFilterTagRequest: () => dispatch(actions.setFilterTagRequest()),
  setFilterClear: () => dispatch(actions.setFilterClear()),
  selectStartDate: dates => dispatch(actions.selectStartDate(dates)),
  selectEndDate: dates => dispatch(actions.selectEndDate(dates)),
  downloadXLSX: () => dispatch(actions.downloadXLSX()),
  downloadCSV: () => dispatch(actions.downloadCSV())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FiltersPanel)
